import createIcon from '../../createIcon';

/**
 * @component @name CalendarViewDay
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMyAxNi41SDIxVjE4LjVIM1YxNi41Wk0zIDkuNUgyMVYxNC41SDNWOS41Wk0zIDUuNUgyMVY3LjVIM1Y1LjVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const CalendarViewDay = createIcon('CalendarViewDay', [
  [
    'path',
    { d: 'M3 16.5H21V18.5H3V16.5ZM3 9.5H21V14.5H3V9.5ZM3 5.5H21V7.5H3V5.5Z', key: '1ltl7o' },
  ],
]);

export default CalendarViewDay;
